import {
  Box,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { lightBlue } from "@material-ui/core/colors";
import { Search } from "@material-ui/icons";
import { bindToggle, usePopupState } from "material-ui-popup-state/hooks";
import React, { useState } from "react";
import { useDataProvider, useTranslate } from "react-admin";
import { useHistory } from "react-router";
import icSearch from "../assets/icons/ic_search.png";
import colors from "./Colors";
import CustomPopoverArrow from "./CustomPopoverArrow";

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
    borderRadius: "2px",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  boxBoder: {
    borderBottom: "1px solid",
    borderRight: "1px solid",
    borderBottomColor: theme.palette.grey["200"],
    borderRightColor: theme.palette.grey["200"],
  },
  underline: {
    "&::before": {
      borderBottom: "1px solid black",
    },
    "&:hover:not($disabled):before": {
      borderBottom: "1px solid black",
    },
  },
  underlineNotValue: {
    "&::before": {
      borderBottom: "1px solid " + colors.lightBlue["200"],
    },
    "&:hover:not($disabled):before": {
      borderBottom: "1px solid" + colors.lightBlue["200"],
    },
  },
  focuses: {
    backgroundColor: "white !important",
  },
  popover: {
    position: "relative",
    marginLeft: "1em",
  },
  header: {
    zIndex: 2,
    position: "relative",
    WebkitBoxShadow: " 0px 5px 5px 0px rgba(0,0,0,0.2)",
    MozBoxShadow: "0px 5px 5px 0px rgba(0,0,0,0.2)",
    boxShadow: "0px 5px 5px 0px rgba(0,0,0,0.2)",
  },
  TextValue: {
    fontFamily: "UniviaPro",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.385,
    letterSpacing: "0.13px",
    color: "#4f5064",
    display: "block",
    width: "90%",

    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  TextId: {
    fontFamily: "UniviaPro",
    fontSize: "11px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.385,
    letterSpacing: "0.13px",
    color: "#237fc2",
    width: "80%",
  },

  btnShowPopover: {
    webkitBoxShadow:
      "0px 10px 13px -7px #000000, 5px 5px 15px 5px rgba(0,0,0,0)",
    boxShadow: "0px 10px 13px -7px #000000, 5px 5px 15px 5px rgba(0,0,0,0)",
  },
}));

const ResultSearchCluster = ({ textHolder }) => {
  const popupState = usePopupState({
    variant: "popper",
    popupId: "searchDialog",
  });

  const [dataClusters, setDataClusters] = useState([]);
  const [loading, setLoading] = useState(false);

  const getClusters = (dataClusters) => {
    setDataClusters(dataClusters);
  };
  return (
    <Box mr={2}>
      <SearchInput
        setLoading={setLoading}
        placeholder={textHolder}
        getList={getClusters}
        {...bindToggle(popupState)}
      />
      <CustomPopoverArrow
        zIndex={1500}
        popupState={popupState}
        placement="bottom"
      >
        <Box
          style={{
            backgroundColor: "#fff",
            width: "600px",
          }}
        >
          {loading && (
            <Box
              style={{
                width: "100%",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}
          {!loading && <FilterSearchCluster data={dataClusters} />}
        </Box>
      </CustomPopoverArrow>
    </Box>
  );
};

export default ResultSearchCluster;

const FilterSearchCluster = ({ data }) => {
  const translate = useTranslate();
  const classes = useStyles();

  const renderResultSearch = () => {
    if (data.length === 0) {
      return (
        <Box
          display="flex"
          width="100%"
          justifyContent="center"
          py={3}
          style={{ backgroundColor: "#fff", textAlign: "center" }}
        >
          <Typography
            className={classes.TextValue}
            style={{ textAlign: "center" }}
          >
            {translate(`pos.dashboard.notfound`)}
          </Typography>
        </Box>
      );
    } else {
      return <ListShowRooms dataList={data} />;
    }
  };

  return (
    <Box>
      <Box
        className={classes.header}
        display="flex"
        mb="2px"
        p={1}
        bgcolor={colors.lightBlue["200"]}
      >
        <Box width="30%">
          <Typography className={classes.TextValue}>
            {translate(`pos.dashboard.cluster`)}
          </Typography>
        </Box>
        <Box width="40%">
          <Typography className={classes.TextValue}>
            {translate(`pos.dashboard.entity`)}
          </Typography>
        </Box>
        <Box width="30%">
          <Typography className={classes.TextValue}>
            {translate(`pos.dashboard.group`)}
          </Typography>
        </Box>
      </Box>
      {data && renderResultSearch()}
    </Box>
  );
};
const ListShowRooms = ({ dataList }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleClickCluster = (entity, group, cluster) => {
    history.push({
      pathname: `/Entity/${encodeURIComponent(entity)}`,
      state: { keyFilterGroup: group, keyFilterCluster: cluster },
    });
  };
  return (
    <Box
      bgcolor="background.paper"
      style={{ maxHeight: 200, overflow: "auto" }}
    >
      <List component="nav" disablePadding>
        {dataList &&
          dataList.map((row, index) => (
            <Box key={index} className={classes.boxBoder}>
              <ListItem
                style={{ padding: "8px" }}
                button
                onClick={() => handleClickCluster(row.entity, row.group, row.name)}
              >
                <Box width="100%" display="flex">
                  <Box width="30%" display="flex" alignItems="center">
                    <Typography className={classes.TextValue}>
                      {row.name || ""}
                    </Typography>
                  </Box>
                  <Box width="40%" display="flex" alignItems="center">
                    <Typography className={classes.TextValue}>
                      {row.entity || ""}
                    </Typography>
                  </Box>
                  <Box width="30%" display="flex" alignItems="center">
                    <Typography className={classes.TextValue}>
                      {row.group || ""}
                    </Typography>
                  </Box>
                </Box>
              </ListItem>
            </Box>
          ))}
      </List>
    </Box>
  );
};

const useStylesTwo = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: 236,
    height: 38,
    paddingLeft: "8px",
    paddingRight: "8px",
    border: "solid 1px " + lightBlue[100],
  },
  iconButton: {
    padding: 0,
    width: 18,
    height: 18,
    marginLeft: 4
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    outline: "none",
    border: "none",
    fontFamily: "UniviaPro",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#88898c",
    opacity: 0.9,
  },
  formSearch: {
    borderRadius: "10px",
    border: " solid 1px #e0f0f2",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    width: 224,
    height: 36,
    paddingLeft: "8px",
    paddingRight: "8px",
  },
  border: {
    borderRadius: "10px",
  },
}));

const SearchInput = ({ setLoading, placeholder, getList, ...props }) => {
  const classes = useStylesTwo();
  const [keySearch, setKeySearch] = useState("");
  const [lastKeySearch, setLastKeySearch] = useState(""); //hold the last key search for saving query
  const [dataClusters, setDataClusters] = useState([]);
  const [error, setError] = useState(true);
  const dataProvider = useDataProvider();

  const checkSearchKey = (value) => {
    return (
      value.name.toLowerCase().includes(keySearch.trim().toLowerCase())
    );
  };

  const onChange = (event) => {
    if (event.target.value) {
      setError(false);
    } else {
      setError(true);
    }
    setKeySearch(event.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!keySearch) {
      setError(true);
    } else if (keySearch !== lastKeySearch) {
      setLoading(true);
      dataProvider("GET_LIST", "ClusterAssign", {
        filter: {},
        pagination: {},
        sort: { field: "name", order: "ASC" },
      }).then(({ data }) => {
        setLastKeySearch(keySearch);
        const dataFilter = data.cluster.filter((cluster) => checkSearchKey(cluster));
        setDataClusters(dataFilter);
        getList(dataFilter);
        setLoading(false);
      });
    } else if (keySearch === lastKeySearch) {
      //avoid it query the last key again
      getList(dataClusters);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <Paper elevation={0} className={classes.formSearch}>
        <img src={icSearch} className={classes.iconButton} alt="" />
        <input
          className={classes.input}
          placeholder={placeholder}
          onChange={onChange}
        />
        <IconButton
          disabled={error}
          type="submit"
          style={{
            marginLeft: "1em",
            padding: "6px",
            backgroundColor: error ? "#f1f1f1" : "#e5f1f8",
          }}
          className={classes.border}
          size="small"
          {...props}
        >
          <Search color={!error ? "primary" : "secondary"} />
        </IconButton>
      </Paper>
    </form>
  );
};
